export default __webpack_public_path__ + "static/media/upload.c5c93d63.svg";